var a = ((a2) => (a2.TrunkMeteringPoint = "9057ef69-7e08-426b-807a-af18fafaffad", a2))(a || {});
export {
  a as MeteringPointTypes
};
//# sourceMappingURL=types.js.map
